import {
  DataTable,
  MainButton,
  ModalConfirmAction,
  PageWrapper,
  STATUSPAGE,
} from '@repo/ui';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

import { makeColumnsEvaluationCriteria } from '../../common/columns/columns-evaluation-criteria';
import { useEvaluationCriteria } from '../../hooks/useEvaluationCriteria';

export const EvalutionCriteria = () => {
  const [criteriaIdToCopy, setCriteriaIdToCopy] = useState('');
  const [isOpenModalCopy, setIsOpenModalCopy] = useState(false);
  function toggleModalCopyCriteria(id?: string) {
    setCriteriaIdToCopy(id);
    setIsOpenModalCopy(!isOpenModalCopy);
  }

  const navigate = useNavigate();
  const { requestCopyEvaluationCriteria, cloneStatus } =
    useEvaluationCriteria();

  const {
    getAllStatus,
    evaluationCriterias,
    requestGetAllEvaluationCriteria,
    requestDeleteEvaluationCriteria,
  } = useEvaluationCriteria();

  useEffect(() => {
    requestGetAllEvaluationCriteria();
  }, []);

  // Constants
  const noDataConfig = {
    noDataTitle: 'Nenhum instrumento de avaliação encontrado',
    noDataDescription:
      'Não há instrumentos de avaliação cadastrados no momento.',
  };

  return (
    <PageWrapper title="Instrumentos de Avaliação">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">Instrumentos de Avaliação</h4>
        </div>

        <MainButton
          onClick={() => {
            navigate('/cadastros/instrumentos-de-avaliacao/novo');
          }}
        >
          <i className="ri-add-line" style={{ fontSize: '1rem' }}></i>
          Novo Instrumento de Avaliação
        </MainButton>
      </div>
      <Card>
        <CardBody>
          <DataTable
            noDataTitle={noDataConfig.noDataTitle}
            noDataDescription={noDataConfig.noDataDescription}
            actions={[
              {
                id: 1,
                name: 'copy',
                label: 'Copiar',
                onPress: (cellProps) => {
                  toggleModalCopyCriteria(cellProps.id);
                },
                nameFeatherIcon: 'copy',
                classNameColorIcon: 'primary',
              },
              {
                id: 2,
                name: 'edit',
                label: 'Editar',
                onPress: (cellProps) => {
                  navigate(
                    `/cadastros/instrumentos-de-avaliacao/editar/${cellProps.id}`,
                  );
                },
                nameFeatherIcon: 'edit',
                classNameColorIcon: 'primary',
              },
            ]}
            canSearch
            pagination
            data={evaluationCriterias || []}
            columns={makeColumnsEvaluationCriteria()}
            loading={getAllStatus === STATUSPAGE.LOADING}
            handleDelete={(id) => requestDeleteEvaluationCriteria({ id })}
            defaultSortAsc
            defaultSortFieldId={1}
            keysSearch={['name']}
          />
        </CardBody>
      </Card>
      <ModalConfirmAction
        loading={cloneStatus === STATUSPAGE.LOADING}
        title="Copiar Instrumento?"
        subtitle="Confirma a cópia deste instrumento de avaliação?"
        isOpen={isOpenModalCopy}
        toggle={() => {
          toggleModalCopyCriteria();
        }}
        onConfirm={() => {
          requestCopyEvaluationCriteria(
            { id: criteriaIdToCopy },
            toggleModalCopyCriteria,
          );
        }}
        modalTheme="primary"
        actionBtnLabel="Sim"
        cancelBtnLabel="Não"
        featherIconName="help-circle"
      />
    </PageWrapper>
  );
};
